import { useSSOStatus } from 'api/configurations';
import React from 'react';
import { useDefaultMappingNavigate } from 'utils/navigation';
import ConfiguredMark from '../ConfigurationsStatus/ConfigurationStatusCards/ConfiguredMark';
import PageBarButton from '../PageBarButton/PageBarButton';

const SSOMappingBarButton: React.FC = () => {
	const { data: ssoStatusData } = useSSOStatus();

	const { navigateToDefaultMapping } = useDefaultMappingNavigate(
		ssoStatusData?.idp?.id,
		ssoStatusData?.method
	);

	return (
		<PageBarButton
			tooltip={
				navigateToDefaultMapping
					? ''
					: intl.tr('home.mappingBarButton.disabledTooltip')
			}
			disabled={!navigateToDefaultMapping}
			onClick={navigateToDefaultMapping}
			data-testid="sso-mapping-bar-button"
			text={intl.tr('general.SSOMapping')}
			rightContent={ssoStatusData?.ssoMappingConfigured && <ConfiguredMark />}
		/>
	);
};

export default SSOMappingBarButton;
